export default __webpack_public_path__ + "029d3521be5b156046c7a7a4df54d4bf.png";